const initialState = {
  selectedRegionId: null,
  allRegionsGroupRegionId: 2692 // EU28: 276
}
const regionsReducer = (state = initialState, action) => {
  switch (action.type) {
  case 'SET_SELECTED_REGION_ID':
    return {
      ...state,
      selectedRegionId: action.selectedRegionId
    }
  case 'SET_SELECTED_REGION_COUNTRY_META':
    return {
      ...state,
      selectedRegionCountryMeta: action.selectedRegionCountryMeta
    }
  case 'SET_REGIONS_DATA':
    return {
      ...state,
      regionsData: action.regionsData
    }
  case 'SET_COUNTRIES_DATA':
    return {
      ...state,
      countriesData: action.countriesData
    }
  case 'SET_REFERENCE_REGIONS_DATA':
    return {
      ...state,
      referenceRegionsData: action.referenceRegionsData
    }
  case 'SET_SAME_COUNTRY_REGIONS_DATA':
    return {
      ...state,
      sameCountryRegionsData: action.sameCountryRegionsData
    }
  default:
    return state
  }
}

export default regionsReducer



// WEBPACK FOOTER //
// ./src/redux/Reducers/regionsReducer.js